import React from 'react';
import NalogRep from '../../components/reports/nalog/NalogRep'


function nalogRepPage(props) {
    return (
        <>
            <NalogRep />
        </>
    );
}

export default nalogRepPage;